import { useCarValuationToolContext } from '../../../CarValuationTool.context';
import { useTimeout } from '../../../../../../../../hooks/UseTimeout.hook';

import {
  PrivateValuationFormInputs,
  mileageUnitSchema,
} from '../../../queries/schema/PrivateValuationSchema';
import { convertMilesToKm } from '../../../../../../../../helpers/formatting';

import { ARTIFICIAL_LOADING_TIME_LENGTH_IN_MILLISECONDS } from '../../../CarValuationTool.constants';

const useOnSubmitValuation = () => {
  const {
    setIsValuationArtificiallyLoading,
    requestCarValuation,
    setRegistrationNumber,
  } = useCarValuationToolContext();

  /**
   * We add an artificial delay when a car valuation is requested.
   * We do this for a number of reasons, including:
   *
   * To sell the illusion that complex processing is happening under the hood;
   * To add legitimacy, a quickly resolved process may be considered casual, while something slower may be considered serious;
   * To make an interface feel smoother, more human, and less jittery;
   * To help guide the eye and creates a rhythm;
   * Lastly, to give users a moment of cognitive closure, allowing them to feel confident something worked.
   */
  const { setTimeoutRef } = useTimeout({
    timeoutCallback: () => setIsValuationArtificiallyLoading(false),
    timeInMilliseconds: ARTIFICIAL_LOADING_TIME_LENGTH_IN_MILLISECONDS,
  });

  const onSubmitCallback = (args: PrivateValuationFormInputs) => {
    const { registrationNumber, mileage, mileageUnit } = args;
    setIsValuationArtificiallyLoading(true);

    /**
     * We set the registration number here so it can be displayed as part of the error screen, if the lookup is unsuccessful
     */
    setRegistrationNumber(registrationNumber);

    const parsedMileage = parseInt(mileage.replace(/,/g, ''));

    const mileageInKilometers =
      mileageUnit === mileageUnitSchema.enum.Kilometres
        ? parsedMileage.toString()
        : convertMilesToKm(parsedMileage);

    requestCarValuation({
      registrationNumber,
      mileageInKilometers,
    });

    setTimeoutRef();
  };

  return {
    onSubmitCallback,
  };
};

export { useOnSubmitValuation };
